import React from 'react';
import {Owner} from './Inc';
import Menus from './Menus';
import Drawer from '@mui/material/Drawer';
import useStyles from './Styles';

interface SideMenuProps {
    owner: Owner,
	isOpen: boolean,
	onClickMenu():void,
	onClose():void,
	hide?: boolean,
}

const SideMenu:React.FC<SideMenuProps> = (props)=> {
	const classes = useStyles();

	if( props.hide!==null && props.hide===true ){
		return (null);
	}

	return (
		<>
			<Drawer
				variant="temporary"
				anchor={"left"}
				open={props.isOpen}
				ModalProps={{
					keepMounted: true, // Better open performance on mobile.
				}}
				onClose={props.onClose}
				sx={{display:{lg:'none',md:'block'}}}
			>
				<div className={classes.drawerTitle}>SideB Menu</div>
				
				<div className={classes.drawerList}>
					<Menus onClick={props.onClickMenu} owner={props.owner}/>
				</div>
			</Drawer>
			<Drawer
				className={classes.drawer}
				variant="permanent"
				anchor="left"
				classes={{
					paper: classes.drawerPaper,
				}}
				open={true}
				sx={{display:{lg:'block',md:'none',sm:'none',xs:'none'}}}
			>
				<Menus onClick={props.onClickMenu} owner={props.owner}/>
			</Drawer>
		</>
	)		
}

export default SideMenu;